import SeccionPageHeader from '../Utils/SeccionPageHeader';

export default function ParametrosMenu(){

    const parametros = [
        {
            title: "Parámetros generales",
            links: [
                { href: "/parametros/sedes", label: "Sedes" },
                { href: "/parametros/roles", label: "Roles" },
                { href: "/parametros/componentes", label: "Componentes" },
                { href: "/parametros/entidades", label: "Entidades" },
                { href: "/parametros/estadosusuario", label: "Estados usuario" },
                { href: "/parametros/usuarios", label: "Usuarios" },
                { href: "/parametros/actividades", label: "Actividades" },
                { href: "/parametros/discapacidades", label: "Discapacidades" },
                { href: "/parametros/causadiscapacidad", label: "Causa discapacidad" },
                { href: "/parametros/sexos", label: "Sexos" },
                { href: "/parametros/minorias", label: "Minorias" },
                { href: "/parametros/entidadeseducativas", label: "Entidad educativa" },
                { href: "/parametros/estadoscivil", label: "Estado civil" },
                { href: "/parametros/programasespeciales", label: "Programas especiales" },
                { href: "/parametros/oficios", label: "Oficios" },
                { href: "/parametros/programasdiscapacidad", label: "Programas discapacidad" },
                { href: "/parametros/razonesnoestudio", label: "Razon no estudio" },
                { href: "/parametros/salud", label: "Salud" },
                { href: "/parametros/razonesnosalud", label: "Razon no salud" },
                { href: "/parametros/tiposestudio", label: "Tipo estudio" },
                { href: "/parametros/tiposidentificacion", label: "Tipo identificacion" },
                { href: "/parametros/departamentos", label: "Departamentos" },
                { href: "/parametros/municipios", label: "Municipio" },
                { href: "/parametros/barrios", label: "Barrios" },
                { href: "/parametros/asentamientos", label: "Asentamientos" },
                { href: "/parametros/parentescos", label: "Parentescos" },
                { href: "/parametros/tipoacompanamiento", label: "Unidad Productiva - Tipo acompañamiento" },
                { href: "/parametros/tipoiniciativa", label: "Unidad Productiva - Tipo iniciativa" },
                { href: "/parametros/naturalezajuridica", label: "Unidad Productiva - Naturaleza jurídica" },
                { href: "/parametros/upubicacioniniciativa", label: "Unidad Productiva - Ubicación iniciativa" },
                { href: "/parametros/uptipotenencia", label: "Unidad Productiva - Tipo tenencia" },
                { href: "/parametros/uprangotiempo", label: "Unidad Productiva - Rango tiempo" },
                { href: "/parametros/tiposinona", label: "Tipos si o no n/a" },
            ],
        },
        {
            title: "Parámetros caracterizacion",
            links: [
                { href: "/parametros/tiposatencion", label: "Atenciones" },
                { href: "/parametros/ayudas", label: "Ayudas" },
                { href: "/parametros/zonas", label: "Zonas" },
                { href: "/parametros/comunas", label: "Comunas" },
                { href: "/parametros/orientacionsexual", label: "Orientacion sexual" },
                { href: "/parametros/identidadgenero", label: "Identidad genero" },
                { href: "/parametros/tiposhabitantecalle", label: "Tipo habitante calle" },
                { href: "/parametros/tiposestrato", label: "Tipo estrato" },
                { href: "/parametros/ayudasporrol", label: "Ayudas X Rol" },
                { href: "/parametros/hechosvictimizantes", label: "Hechos victimizantes" },
                { href: "/parametros/tiposayudas", label: "Tipos ayudas" },
                { href: "/parametros/tiposatenciones", label: "Tipos atenciones" },
                { href: "/parametros/tipoentregaxtipoahu", label: "Tipos entrega x tipo AHU" },
                { href: "/parametros/tiponaturalezaxtipoentrega", label: "Tipos naturaleza x tipos entrega" },
            ],
        },
        {
            title: "Parámetros diagnostico base",
            links: [
                { href: "/parametros/dx/sedes", label: "Sedes" },
                { href: "/parametro/diagnostico/fichosdia", label: "Fichos dia" },
                { href: "/parametros/dx/categorias", label: "Categorias" },
                { href: "/parametros/dx/caracterizaciondfi", label: "Caracterizacion DFI" },
            ],
        },
        {
            title: "Parámetros permisos y roles",
            links: [
                { href: "/parametros/modulos", label: "Modulos" },
                { href: "/parametros/pmodulos", label: "Paginas modulos" },
                { href: "/parametros/ppaginas", label: "Paginas" },
                { href: "/parametros/ppermisospagroles", label: "Permisos pag x roles" },
            ],
        },
        {
            title: "Parámetros organizaciones",
            links: [
                { href: "/parametros/lineasaccion", label: "Líneas de acción" },
                { href: "/parametros/tipoeventos", label: "Tipo acompañamiento" },
                { href: "/parametros/tipoactividades", label: "Tipo actividades" },
                { href: "/parametros/subactividades", label: "Tipo subactividades" },
            ],
        },
        {
            title: "Parámetros DDHH",
            links: [
                { href: "/parametros/ingresoseconomicos", label: "Ingresos económicos" },
                { href: "/parametros/modalidadhomicidios", label: "Modalidad homicidios" },
                { href: "/parametros/mediohomicidios", label: "Medio homicidios" },
                { href: "/parametros/presuntosvictimarios", label: "Presuntos victimarios" },
                { href: "/parametros/tiporeporteseguimiento", label: "Tipo reporte seguimiento" },
                { href: "/parametros/estadocaso", label: "Estado caso" },
                { href: "/parametros/condicionesmigratorias", label: "Condiciones migratorias" },
                { href: "/parametros/tipoatencionddhh", label: "Tipo atencion DDHH" },
                { href: "/parametros/tipovulneracionddhh", label: "Tipo vulneración DDHH" },
                { href: "/parametros/entidadrelacionddhh", label: "Entidades relación DDHH" },
                { href: "/parametros/tipostrata", label: "Tipos de trata" },
                { href: "/parametros/tipoquienbrindainfo", label: "Tipos de quien brinda info" },
                { href: "/parametros/perfilesvictima", label: "Perfiles de víctima" },
                { href: "/parametros/esquemasseguridad", label: "Esquema de Seguridad" },
                { href: "/parametros/estadobusqueda", label: "Estado de búsqueda" },
                { href: "/parametros/modalidaddesaparicion", label: "Modalidad de desaparición" },
                { href: "/parametros/fuenteinformacion", label: "Fuente de información" },
                { href: "/parametros/posiblescausas", label: "Posibles causas" },
                { href: "/parametros/modalidadreclutamiento", label: "Modalidad de reclutamiento" },
                { href: "/parametros/lineasvulnerabilidad", label: "Líneas de vulnerabilidad" },
                { href: "/parametros/tipoatencionxrol", label: "Tipo atención x rol" },
                { href: "/parametros/tipocontactoredcaptadora", label: "Tipos contacto red captadora" },
                { href: "/parametros/promesascaptacion", label: "Promesas captación" },
                { href: "/parametros/mecanismosexplotacion", label: "Mecanismos explotación" },
                { href: "/parametros/tratadocumentoretenido", label: "Tratado documento retenido" },
                { href: "/parametros/trataredsegura", label: "Trata red segura" },
                { href: "/parametros/antecedentestrata", label: "Antecedentes trata" },
                { href: "/parametros/requerimientoapoyosexual", label: "Requerimiento apoyo sexual" },
                { href: "/parametros/tipovaloracionriesgotrata", label: "Tipo valoración riesgo trata" },
                { href: "/parametros/tipoacompespecializadotrata", label: "Tipo acompañamiento especializado trata" },
                { href: "/parametros/tipotramiteregulacion", label: "Tipo tramite regulacion" },
                { href: "/parametros/tratarequierederivacionprograma", label: "Trata requiere derivacion programa" },
                { href: "/parametros/trataexpectativavida", label: "Trata expectativa de vida" },
                { href: "/parametros/tratanecesidadesinmediatas", label: "Trata necesidades inmediatas" },
                { href: "/parametros/vstipomedidaproteccion", label: "Tipos de medida de protección" },
                { href: "/parametros/vsinterpusodenunciapenal", label: "Interpuso denuncia penal" },
                { href: "/parametros/vsactivacodigofucsia", label: "Activa código fucsia" },
                { href: "/parametros/vsconvivenciaagresor", label: "Convivencia agresor" },
                { href: "/parametros/vsnropresuntosagresores", label: "Número presuntos agresores" },
                { href: "/parametros/vstipoposicionpoder", label: "Tipos de posición de poder" },
                { href: "/parametros/vstipomedioutilizado", label: "Tipos de medio utilizado" },
                { href: "/parametros/vstiporepeticionmetodo", label: "Tipos de repetición de método" },
                { href: "/parametros/vsmodalidadhecho", label: "Modalidad de hecho" },
                { href: "/parametros/vstipoactivacionriesgo", label: "Tipo activación riesgo" },
                { href: "/parametros/tiporutaactivada", label: "Tipo ruta activada" },
                { href: "/parametros/motivoatencion", label: "Motivo atención" },
                { href: "/parametros/tiposeguimiento", label: "Tipo seguimiento" },
                { href: "/parametros/busquedainstireceptora", label: "Busqueda insti receptora" },
                { href: "/parametros/busquedarutaposthallazgo", label: "Busqueda ruta post hallazgo" },
                { href: "/parametros/busquedagarantiassalidacampo", label: "Busqueda garantías salida campo" },
                { href: "/parametros/busquedatipofirmaecard", label: "Busqueda tipo firma e card" },
                { href: "/parametros/busquedaconsumospa", label: "Busqueda consumos pa" },
                { href: "/parametros/busquedaredsocial", label: "Busqueda red social" },
                { href: "/parametros/busquedaamenazaprevios", label: "Busqueda amenazas previos" },
                { href: "/parametros/busquedaestatura", label: "Busqueda estatura" },
                { href: "/parametros/busquedacolorcabello", label: "Busqueda color cabello" },
                { href: "/parametros/busquedatipocabello", label: "Busqueda tipo cabello" },
                { href: "/parametros/busquedatonopiel", label: "Busqueda tono piel" },
                { href: "/parametros/busquedaparticularesvisibles", label: "Busqueda particulares visibles" },
                { href: "/parametros/busquedaperfilaltoriesgo", label: "Busqueda perfil alto riesgo" },
                { href: "/parametros/reclutafactoresriesgo", label: "Factores de riesgo" },
                { href: "/parametros/reclutamodocaptacion", label: "Modo de captación" },
                { href: "/parametros/reclutatipousoutilizacion", label: "Tipo de uso de utilización" },
                { href: "/parametros/reclutagrupoarmado", label: "Grupo armado" },
                { href: "/parametros/reclutapresenciaamenazas", label: "Presencia de amenazas" },
                { href: "/parametros/reclutanivelriesgo", label: "Nivel de riesgo" },
                { href: "/parametros/reclutavinculacionalerta", label: "Vinculación alerta" },
                { href: "/parametros/reclutasituaciondesplazamiento", label: "Situación desplazamiento" },
                { href: "/parametros/reclutamedidaproteccion", label: "Medida de protección" },
                { href: "/parametros/reclutaestadomedidafiscalia", label: "Estado medida fiscalia" },
                { href: "/parametros/liderejeliderasgo", label: "Lider eje Liderazgo" },
                { href: "/parametros/liderambitoterritorial", label: "Lider ámbito territorial" },
                { href: "/parametros/liderrangotiempos", label: "Lider rango tiempos" },
                { href: "/parametros/lidernropersonasacargo", label: "Lider nro personas a cargo" },
                { href: "/parametros/lidercanalagresion", label: "Lider canal agresión" },
                { href: "/parametros/liderimpactocomunitario", label: "Lider impacto comunitario" },
                { href: "/parametros/lidervinculosistemaalerta", label: "Lider vinculo sistema alerta" },
                { href: "/parametros/liderpsicosocialrequerida", label: "Lider psicosocial requerida" },
            ],
        },
        {
            title: "Parámetros Reincorporados",
            links: [
                { href: "/reincorporados/parametros/tipoasesoria", label: "Tipos de Asesoría" },
                { href: "/reincorporados/parametros/entidadesacompanamiento", label: "Entidades de Acompañamiento" },
                { href: "/reincorporados/parametros/tipostalleres", label: "Tipos de Talleres" },
                { href: "/reincorporados/parametros/bolsasempleo", label: "Bolsas de Empleo" },
                { href: "/reincorporados/parametros/tiposserviciosferia", label: "Tipos de Servicios Feria" },
                { href: "/reincorporados/parametros/tiposeducacionsuperior", label: "Tipos de Educación Superior" },
                { href: "/reincorporados/parametros/estadoremision", label: "Estado de Remisión" },
                { href: "/reincorporados/parametros/estadoprocesoempleabilidad", label: "Estado proceso empleabilidad" },
                { href: "/reincorporados/parametros/estadonivelformacion", label: "Estado nivel formación" },
                { href: "/reincorporados/parametros/tiposvinculacion", label: "Tipos de Vinculación" },
                { href: "/reincorporados/parametros/estadoformalizacionproductiva", label: "Estado Formalización Productiva" },
                { href: "/reincorporados/parametros/redessociales", label: "Redes Sociales" },
                { href: "/reincorporados/parametros/tipoatencionunidadproductiva", label: "Tipo atención unidad productiva" },
                { href: "/reincorporados/parametros/linearestaurativa", label: "Línea Restaurativa" },
                { href: "/reincorporados/parametros/tipoacompanamientotecnico", label: "Tipos de Acompañamiento Técnico" },
                { href: "/reincorporados/parametros/tiposcompareciente", label: "Tipos de Compareciente" },
                { href: "/reincorporados/parametros/tiposfortalecimiento", label: "Tipos de Fortalecimiento" },
                { href: "/reincorporados/parametros/casosmacrocaso", label: "Casos Macrocaso" },
                { href: "/reincorporados/parametros/tiposjusticia", label: "Tipos de Justicia" },
                { href: "/reincorporados/parametros/rutasantejep", label: "Tipos de rutas ante la JEP" },
                { href: "/reincorporados/parametros/sectorproductivo", label: "Sectores productivos" },
                { href: "/reincorporados/parametros/hechovictimizante", label: "Hecho Victimizante" },
            ],
        }
    ];

    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Menú parámetros"
                idCabezaFamilia="0"
                url="/parametros"
                nombreurl="Menú parámetros"
                nombreform=" Menú parámetros"
            />
            <section className="content">
                <div className="container-fluid">
                    {parametros.map((categoria) => (
                        <div className="row" key={categoria.title}>
                            <div className="col-md-12">
                                <div className="card card">
                                    <div className="card-header">
                                        <h3 className="card-title">{categoria.title}</h3>
                                    </div>
                                    <div className="card-body">
                                        <ul className="nav nav-treeview">
                                            {categoria.links.map((link) => (
                                                <li className="nav-item mr-2 mb-2" key={link.href}>
                                                    <a href={link.href} className="btn btn-outline-primary">
                                                        <span>{link.label}</span>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}